import { nsSimCard } from '@/app/i18n/namespaces';
import SIM_CARDS from '../../api/apiUrls';
import Entity from '@/common-utils/components/renders/entity/Entity';

const SimImportProps = {
    apiUrl: SIM_CARDS.FILE_ACTION.url,
    namespace: nsSimCard,
    fileExampleProperties: {
        name: 'sim_operations_example.csv',
        path: '/static/resource/files/sim_operations_example.csv'
    },
    uploadProperties: {
        fileExtAccepted: ['.csv'],
        typeOfUpload: 'text',
        invalidFileEntity: 'modal.import.error.invalid_file',
        maxSize: 10485760
    },
    countLines: (fileData) => {
        const counters = {
            activations: 0,
            terminations: 0
        };
        const lines = fileData.split('\n');
        for (const line of lines) {
            const [operation] = line.split(';');
            if (operation === 'ACTIVATION') {
                ++counters.activations;
            } else if (operation === 'DELETION') {
                ++counters.terminations;
            }
        }
        return { numberOfLines: counters, file: fileData };
    },
    explanations: () => {
        return (<>
            <Entity entity='modal.import.explanations.header' namespace={nsSimCard} />
            <ul className='list-disc list-outside [&_ul]:list-[revert] ml-8'>
                <li><Entity entity='modal.import.explanations.operation' namespace={nsSimCard} /></li>
                <li><Entity entity='modal.import.explanations.iccid' namespace={nsSimCard} /></li>
                <li>
                    <Entity entity='modal.import.explanations.contract' namespace={nsSimCard} />
                    <ul className='list-outside ml-8'>
                        <li><Entity entity='modal.import.explanations.offers.ing_2' namespace={nsSimCard} /></li>
                        <li><Entity entity='modal.import.explanations.offers.ing_5' namespace={nsSimCard} /></li>
                        <li><Entity entity='modal.import.explanations.offers.ing_10' namespace={nsSimCard} /></li>
                        <li><Entity entity='modal.import.explanations.offers.ing_50' namespace={nsSimCard} /></li>
                        <li><Entity entity='modal.import.explanations.offers.ing_100' namespace={nsSimCard} /></li>
                    </ul>
                </li >
                <li><Entity entity='modal.import.explanations.client' namespace={nsSimCard} /></li>
            </ul >
        </>);
    },
    confirmation: (numberOfLines) => {
        return <Entity
            entity='modal.import.confirmation'
            namespace={nsSimCard}
            data={{ activations: numberOfLines.activations, terminations: numberOfLines.terminations }}
        />;
    }
};

export default SimImportProps;